import React, { createContext, useContext, useEffect, useState } from "react";

export const PREVIEW_SLUG = "__preview__";
export const PREVIEW_MESSAGE = "rhm-product-preview";
export const EDIT_MESSAGE = "rhm-product-edit";

export const PreviewCtx = createContext({ editing: false });

export const postEdit = (payload) =>
    window.parent?.postMessage({ type: EDIT_MESSAGE, payload }, "*");

// Live preview channel: the CRM posts a draft product + layout, the public page renders it as-is.
export const useProductPreview = () => {
    const isPreview = typeof window !== "undefined"
        && new URLSearchParams(window.location.search).get("preview") === "1";
    const [draft, setDraft] = useState(null);

    useEffect(() => {
        if (!isPreview) return undefined;
        const onMessage = (event) => {
            if (event.data?.type === PREVIEW_MESSAGE) setDraft(event.data.payload || null);
        };
        window.addEventListener("message", onMessage);
        window.parent?.postMessage({ type: `${PREVIEW_MESSAGE}-ready` }, "*");
        return () => window.removeEventListener("message", onMessage);
    }, [isPreview]);

    return { isPreview, draft };
};

/** Click-to-edit product text. Outside the preview it renders as plain markup. */
export const PEdit = ({ path, value, as: Tag = "span", className = "", children,
    multiline = false, label = "" }) => {
    const { editing } = useContext(PreviewCtx);
    if (!editing) return <Tag className={className}>{children ?? value}</Tag>;
    return (
        <Tag className={`${className} rhm-editable`} title="Click to edit"
            data-testid={`pv-edit-${path}`}
            onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                postEdit({ kind: "product-text", path, value: value ?? "", multiline, label });
            }}>
            {children ?? value}
        </Tag>
    );
};
